// Parse and/or Validate
import { validation as v8n, parse } from '../../src/common/validation'

/**
 * Configurable properties 'published' by this "Request" plugin.
 * NOTE: Do NOT expose the config properties (related to this plugin) to the public API documentation.
 *
 * @property {boolean} [injectAgentVersionHeader=true] Option to automatically inject an agent version header to every REST request.
 *            This header is used to help with diagnostics and analytics in a completely anonymous fashion.
 *
 * @property {string} [customAgentVersionHeaderSuffix=''] Additional custom information that can be appended to the agent version header's value.
 *           This additional suffix value is only used when injectAgentVersionHeader property is enabled.
 */
export const defaultOptions = {
  injectAgentVersionHeader: true,
  customAgentVersionHeaderSuffix: ''
}

const v8nValidation = v8n.schema({
  injectAgentVersionHeader: v8n.boolean()
})
export const parseOptions = parse('request', v8nValidation)
